import React, { useState, useEffect, useRef } from 'react';
import { StyledMarkdownText } from './StyledMarkdownText';
import { useAnimationFrame } from './useAnimationFrame';
export const TextTyper = _ref => {
  let {
    text,
    typingSpeed = 15,
    onTypingEnd = () => {},
    onTyping = () => {}
  } = _ref;
  const mountTime = useRef(performance.now());
  const [currentIndex, setCurrentIndex] = useState(0);
  const displayText = text.slice(0, currentIndex);
  const isTypingEnd = currentIndex >= text.length;
  useAnimationFrame(time => {
    const millisecondsPassed = time - mountTime.current;
    const nextIndex = Math.floor(millisecondsPassed / typingSpeed);
    if (nextIndex !== currentIndex) {
      setCurrentIndex(nextIndex);
    }
  }, !isTypingEnd);
  const lastOnTypingIndexReported = useRef(0);
  const isTypingEndReported = useRef(false);

  // Call onTyping on each typing iteration
  useEffect(() => {
    if (currentIndex !== lastOnTypingIndexReported.current) {
      onTyping();
      lastOnTypingIndexReported.current = currentIndex;
    }
  }, [currentIndex, onTyping]);

  // Call onTypingEnd when the typing ends
  useEffect(() => {
    if (isTypingEnd && !isTypingEndReported.current) {
      onTypingEnd();
      isTypingEndReported.current = true;
    }
  }, [isTypingEnd, onTypingEnd]);

  // Call onTypingEnd in case the component is unmounted before the typing ends
  useEffect(() => () => {
    if (!isTypingEndReported.current) {
      onTypingEnd();
      isTypingEndReported.current = true;
    }
  },
  // eslint-disable-next-line
  []);
  return /*#__PURE__*/React.createElement("div", {
    "data-is-typing-end": isTypingEnd
  }, /*#__PURE__*/React.createElement(StyledMarkdownText, null, ensureClosedMarkdown(displayText)));
};

// to type without markdown tag. immediately with styles
function ensureClosedMarkdown(input) {
  let output = input.trim();
  const markdownTags = [{
    open: '_',
    close: '_'
  }, {
    open: '__',
    close: '__'
  }, {
    open: '**',
    close: '**'
  }, {
    open: '*',
    close: '*'
  }, {
    open: '~~',
    close: '~~'
  }, {
    open: '```',
    close: '\n```'
  }, {
    open: '`',
    close: '`'
  }];
  for (const tag of markdownTags) {
    const openCount = (input.match(new RegExp(escapeRegExp(tag.open), 'g')) || []).length;
    const tagCount = openCount;
    const shouldAddCloseTag = tagCount % 2 !== 0;
    if (shouldAddCloseTag) {
      output += tag.close;
    }
  }

  // TODO: fix only for bold. meeds to make this generic
  output = output.replace(/\*{3,}/g, '**');
  return output;
}
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
//# sourceMappingURL=TextTyper.js.map